import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import {
  SharedGridPadding,
  SharedGridStyleNoPadding,
} from "features/CenterContent/shared/MainContentGrid";
import {
  VehicleAlertResponse,
  VehicleAlertResponseSchema,
} from "features/CenterContent/shared/TilsynAlerts/schema";
import TilsynAlerts from "features/CenterContent/shared/TilsynAlerts/TilsynAlerts";
import { HeadedContainerSticky } from "features/CenterContent/VehicleDetails/shared/HeadedContainerSticky";
import { DetailsParams } from "features/CenterContent/VehicleDetails/TrainDetails/TrainDetails";
import { useParams } from "react-router-dom";
import { FailureMessage } from "shared/components/feedback/FailureMessage/FailureMessage";
import { Text } from "shared/components/Spor";

const VehicleAlerts = () => {
  const { trainNumber, trainDate, countryCode } = useParams<DetailsParams>();

  const { data, isLoading, isError, isSuccess } = useQuery({
    queryKey: [
      "getActiveVehicleAlertsForTrain",
      countryCode,
      trainNumber,
      trainDate,
    ],
    refetchInterval: 60000,
    queryFn: ({ signal }) =>
      axiosClient
        .get<VehicleAlertResponse>(
          `${getBackendUrl()}/vehicle-alerts/${countryCode}/${trainDate}/${trainNumber}`,
          {
            signal,
          },
        )
        .then((res) => VehicleAlertResponseSchema.parse(res.data)),
  });

  const isLoadingOrNoData = isLoading || !data || data.alerts.length <= 0;
  if (!isError && isLoadingOrNoData) {
    return null;
  }

  return (
    <HeadedContainerSticky
      panelStyle={SharedGridStyleNoPadding}
      headerHeight="54px"
      variant="main"
      header={
        <Text variant="xs" fontWeight={600} mr="auto" p={SharedGridPadding}>
          Alarmer i Tilsyn
        </Text>
      }
    >
      <>
        {isError && (
          <FailureMessage customMessage="Kunne ikke hente alarmer i Tilsyn for dette toget." />
        )}
        {isSuccess && (
          <TilsynAlerts
            alerts={data?.alerts}
            isLoading={false}
            isSuccess={isSuccess}
          />
        )}
      </>
    </HeadedContainerSticky>
  );
};

export default VehicleAlerts;
